export default __webpack_public_path__ + "static/media/that_s_ok.ed9a2b02.mp3";